import React from 'react';

const About = () => {
  return (
     <section id="about" className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <p className="text-[11px] tracking-[0.3em] text-gray-500 mb-4">
              HAQQIMIZDA
            </p>
            <h2 className="text-3xl lg:text-4xl font-serif mb-8">
              SƏSSİZ LÜKSÜN ESTETİKASI
            </h2>
            <div className="max-w-3xl mx-auto">
              <p className="text-gray-600 leading-relaxed mb-6">

                L'Aliel, yüksək keyfiyyəti və incə zövqü həyat tərzinə çevirən qadınların brendidir.
                Qışqıran rənglərdən uzaq, lakonik və kübar cizgilərlə premium parçaları bir araya gətirərək qarderobunuza səs-kürsüz bir asillik qatırıq.
               Hər bir kolleksiyamız, yalnız ən yaxşı materialların və sənət səviyyəsindəki toxunuşların vəhdətindən doğur.
              </p>
            </div>
          </div>
        </section>
  );
};

export default About;